import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
export function EmotionalCloseSection() {
  const [ref, isInView] = useInView({
    threshold: 0.15
  });
  return <section className="relative min-h-[50vh] sm:min-h-[60vh] flex items-end justify-center overflow-hidden" data-id="element-225">
      <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/ChatGPT_Image_26_abr_2026_06_26_30_a.m.4.png?v=1777199448" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover object-center z-0" loading="lazy" decoding="async" data-id="element-226" />

      {/* Overlay */}
      <div className="absolute inset-0 z-[1]" style={{
      background: 'linear-gradient(0deg, #0A0A0B 15%, rgba(10,10,11,0.6) 50%, #0A0A0B 95%)'
    }} data-id="element-227" />

      {/* Golden glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-xl h-full bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.06),transparent_50%)] pointer-events-none z-[2]" data-id="element-228" />

      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 20
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.8
    }} className="relative z-10 text-center pb-16 sm:pb-24 px-4 max-w-2xl mx-auto" data-id="element-229">
        <p className="font-serif text-xl sm:text-3xl md:text-4xl font-bold text-white max-w-xl mx-auto leading-tight drop-shadow-lg mb-5 sm:mb-7" data-id="element-230">
          La claridad no aparece de golpe.
          <br data-id="element-231" />
          <span className="text-gold" data-id="element-232">
            Se construye en los momentos que decides crear para ti.
          </span>
        </p>

        <p className="text-white/75 text-sm sm:text-base md:text-lg leading-relaxed max-w-lg mx-auto mb-8 sm:mb-10 font-medium" data-id="element-233">
          Empieza tu experiencia privada de lectura, introspección y conexión
          interior.
        </p>

        <button onClick={() => {
        document.getElementById('comparacion')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="bg-gold text-dark min-h-[52px] py-4 px-8 sm:px-12 text-sm sm:text-base font-black rounded-xl shadow-[0_15px_40px_rgba(212,175,55,0.4)] hover:shadow-[0_20px_50px_rgba(212,175,55,0.6)] hover:bg-yellow-400 active:scale-[0.97] transition-all duration-300 uppercase tracking-wider" data-id="element-234">
          Comenzar Experiencia
        </button>
      </motion.div>
    </section>;
}